import { Stack, ButtonGroup, Button } from "@mui/material";
import classNames from "classnames";
import { PaymentFrequency } from "../../__generated__/types";

export const MembershipsListPillButtons = ({
  paymentFrequency,
  setPaymentFrequency,
}: {
  paymentFrequency: PaymentFrequency;
  setPaymentFrequency: (value: PaymentFrequency) => void;
}) => {
  return (
    <Stack
      className="pill-btn-container"
      direction="row"
      justifyContent="end"
      sx={{ mb: '32px' }}
    >
      <ButtonGroup
        variant="outlined"
        sx={{
          mx: "auto",
          "& .MuiButtonBase-root": {
            fontSize: "14px",
            borderRadius: "0 !important",
          },
          "& .MuiButtonBase-root:first-child": {
            fontSize: "14px",
            borderTopLeftRadius: "8px !important",
            borderBottomLeftRadius: "8px !important",
          },
          "& .MuiButtonBase-root:last-child": {
            fontSize: "14px",
            borderTopRightRadius: "8px !important",
            borderBottomRightRadius: "8px !important",
          },
        }}
      >
        <Button
          variant={
            paymentFrequency === PaymentFrequency.BiAnnually
              ? "contained"
              : "outlined"
          }
          className={classNames(
            "pill-btn",
            paymentFrequency === PaymentFrequency.BiAnnually && "active"
          )}
          onClick={() => setPaymentFrequency(PaymentFrequency.BiAnnually)}
        >
          Bi-Annually
        </Button>
        <Button
          variant={
            paymentFrequency === PaymentFrequency.Annually
              ? "contained"
              : "outlined"
          }
          className={classNames(
            "pill-btn",
            paymentFrequency === PaymentFrequency.Annually && "active"
          )}
          onClick={() => setPaymentFrequency(PaymentFrequency.Annually)}
        >
          Annually
        </Button>
        <Button
          variant={
            paymentFrequency === PaymentFrequency.Monthly
              ? "contained"
              : "outlined"
          }
          className={classNames(
            "pill-btn",
            paymentFrequency === PaymentFrequency.Monthly && "active"
          )}
          onClick={() => setPaymentFrequency(PaymentFrequency.Monthly)}
        >
          Monthly
        </Button>
      </ButtonGroup>
    </Stack>
  );
};
